/*
  Puff Land – lectures et votes 👍 / 👎 des articles (guides et actualités).
  Service de compteurs gratuit et public (Abacus), choisi par le propriétaire le 02/11/2026 :
    GET <api>/hit/<espace>/<clé> : ajoute 1 et renvoie { value }
    GET <api>/get/<espace>/<clé> : renvoie { value } (404 si le compteur n'existe pas encore = 0)
  Compteurs : v-<poignée> (lectures), u-<poignée> (👍), d-<poignée> (👎) ; totaux par rubrique : v-k-guide, u-k-guide, d-k-guide
  (guides) et v-k-news, u-k-news, d-k-news (actualités), pour le récapitulatif en haut des pages Blog et Guide Puff Land.
  Réglages et textes : snippets/article-stats.liquid (part: 'config').
  Si le service ne répond pas, rien ne casse : les chiffres restent masqués et le vote est seulement retenu sur l'appareil.
*/
(() => {
  if (window.__plArticleStats) return;
  window.__plArticleStats = true;

  const cfgEl = document.querySelector('script.pl-art-stats-config');
  if (!cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const API = String(cfg.api || '').replace(/\/+$/, '');
  const NS = cfg.ns || 'puffland-fr';
  const T = cfg.t || {};
  const MIN_VOTES = Number(cfg.minVotes) || 3;
  const lang = document.documentElement.lang || 'fr';
  const nf = new Intl.NumberFormat(lang);
  const nfCompact = (() => { try { return new Intl.NumberFormat(lang, { notation: 'compact', maximumFractionDigits: 1 }); } catch (e) { return nf; } })();
  const pctFmt = (p) => { try { return new Intl.NumberFormat(lang, { style: 'percent', maximumFractionDigits: 0 }).format(p / 100); } catch (e) { return p + ' %'; } };
  let pr;
  try { pr = new Intl.PluralRules(lang); } catch (e) { pr = { select: (n) => (n <= 1 ? 'one' : 'other') }; }
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isBot = navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|headless|preview|pingdom|gtmetrix/i.test(navigator.userAgent || '');
  const designMode = !!(window.Shopify && window.Shopify.designMode);

  const ls = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* stockage bloqué : sans conséquence */ } }
  };
  const ss = {
    get(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* idem */ } }
  };

  // Clé de compteur : lettres, chiffres, « - _ . », 64 caractères au plus (contrainte du service)
  const key = (prefix, handle) => (prefix + '-' + handle).replace(/[^A-Za-z0-9_.-]/g, '-').slice(0, 64);
  const withTimeout = (p, ms) => Promise.race([p, new Promise((_, rej) => setTimeout(() => rej(new Error('timeout')), ms || 6000))]);
  const call = (action, k) => withTimeout(
    fetch(`${API}/${action}/${encodeURIComponent(NS)}/${encodeURIComponent(k)}`, { mode: 'cors', credentials: 'omit', cache: 'no-store' })
      .then((r) => {
        if (r.status === 404) return { value: 0 };
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then((d) => Math.max(0, Number(d && (d.value ?? d.count)) || 0))
  );
  const getCount = (k) => call('get', k);
  const hitCount = (k) => call('hit', k);

  const plural = (n, one, other) => String(pr.select(n) === 'one' ? (one || other || '') : (other || one || '')).replace('__N__', nf.format(n));

  // Petit compteur animé (0 → n), désactivé si l'utilisateur limite les animations
  const animateNumber = (el, n, format) => {
    if (reduceMotion || n < 10) { el.textContent = format(n); return; }
    const start = performance.now();
    const dur = 700;
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = format(Math.round(n * eased));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  /* ---------- Page d'un article ---------- */
  const page = document.querySelector('[data-art-page]');
  if (page && API) {
    const h = page.getAttribute('data-art-page');
    const kind = page.getAttribute('data-art-kind') === 'news' ? 'news' : 'guide';
    const kV = key('v', h);
    const kU = key('u', h);
    const kD = key('d', h);
    const seenKey = 'pl-art-seen:' + h;
    const voteKey = 'pl-art-vote:' + h;

    // Lectures : une lecture par visiteur et par article toutes les 12 heures, hors robots et éditeur de thème
    const last = Number(ls.get(seenKey) || 0);
    const countIt = cfg.count !== false && !isBot && !designMode && Date.now() - last > 12 * 3600 * 1000;
    const viewsEls = document.querySelectorAll(`[data-art-views="${CSS.escape(h)}"]`);
    (countIt ? hitCount(kV) : getCount(kV))
      .then((n) => {
        if (countIt) { ls.set(seenKey, String(Date.now())); hitCount(key('v', 'k-' + kind)).catch(() => {}); }
        if (n < 1) return;
        ss.set('pl-art-v:' + h, { n, t: Date.now() });
        viewsEls.forEach((el) => {
          const out = el.querySelector('[data-n]');
          el.hidden = false;
          animateNumber(out, n, (x) => plural(x, T.view_one, T.view_other));
        });
      })
      .catch(() => { /* service indisponible : on n'affiche rien */ });

    // Votes
    const panel = document.querySelector(`[data-art-vote="${CSS.escape(h)}"]`);
    const usefulEl = document.querySelector('[data-art-useful]');
    const usefulImg = document.querySelector('[data-art-useful-img]');
    const thumbsEl = document.querySelector('[data-art-thumbs]');
    const counts = { up: null, down: null };
    let mine = ls.get(voteKey);
    if (mine !== 'up' && mine !== 'down') mine = null;

    const render = (justVoted) => {
      const known = counts.up !== null && counts.down !== null;
      const total = known ? counts.up + counts.down : 0;
      const pct = total > 0 ? Math.round((counts.up * 100) / total) : 0;
      [usefulEl, usefulImg].forEach((el) => {
        if (!el) return;
        if (known && total >= MIN_VOTES) {
          el.querySelector('[data-n]').textContent = String(T.useful_short || '').replace('__P__', pct);
          el.setAttribute('title', plural(total, T.vote_one, T.vote_other));
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
      // Pastille en haut à droite : toujours visible ; « 👍 👎 Votre avis » tant que les compteurs n'ont pas répondu,
      // puis « 👍 12 · 👎 1 » (même à 0)
      if (thumbsEl && known) {
        thumbsEl.querySelector('[data-up]').textContent = nf.format(counts.up);
        thumbsEl.querySelector('[data-down]').textContent = nf.format(counts.down);
        thumbsEl.classList.remove('is-empty');
        const lbl = String(T.thumbs_label || '').replace('__U__', nf.format(counts.up)).replace('__D__', nf.format(counts.down));
        thumbsEl.setAttribute('aria-label', lbl);
        thumbsEl.setAttribute('title', total > 0 ? String(T.useful_short || '').replace('__P__', pct) + ' · ' + plural(total, T.vote_one, T.vote_other) : (T.be_first || lbl));
      }
      if (!panel) return;
      ['up', 'down'].forEach((v) => {
        const btn = panel.querySelector(`[data-vote="${v}"]`);
        const c = panel.querySelector(`[data-vote-count="${v}"]`);
        btn.setAttribute('aria-pressed', mine === v ? 'true' : 'false');
        btn.classList.toggle('is-chosen', mine === v);
        btn.disabled = !!mine;
        if (known && total > 0) { c.textContent = nf.format(counts[v]); c.hidden = false; } else { c.hidden = true; }
      });
      panel.classList.toggle('has-voted', !!mine);
      const result = panel.querySelector('[data-vote-result]');
      const summary = panel.querySelector('[data-vote-summary]');
      const bar = panel.querySelector('[data-vote-bar]');
      if (known) {
        result.hidden = false;
        if (total > 0) {
          bar.style.width = pct + '%';
          bar.parentElement.hidden = false;
          summary.textContent = String(T.useful || '').replace('__P__', pct) + ' · ' + plural(total, T.vote_one, T.vote_other);
        } else {
          bar.parentElement.hidden = true;
          summary.textContent = T.be_first || '';
        }
      } else {
        result.hidden = true;
      }
      const msg = panel.querySelector('[data-vote-msg]');
      const contact = panel.querySelector('[data-vote-contact]');
      if (mine) {
        msg.textContent = justVoted ? (mine === 'up' ? T.thanks_up : T.thanks_down) : T.already;
        contact.hidden = mine !== 'down';
      } else {
        msg.textContent = '';
        contact.hidden = true;
      }
    };

    Promise.all([getCount(kU), getCount(kD)])
      .then(([u, d]) => { counts.up = u; counts.down = d; render(false); })
      .catch(() => render(false));

    if (panel) {
      render(false);
      panel.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vote]');
        if (!btn || mine) return;
        const v = btn.getAttribute('data-vote');
        mine = v;
        ls.set(voteKey, v);
        if (counts[v] !== null) counts[v] += 1;
        btn.classList.add('is-pop');
        setTimeout(() => btn.classList.remove('is-pop'), 600);
        render(true);
        if (isBot || designMode) return;
        hitCount(key(v === 'up' ? 'u' : 'd', 'k-' + kind)).catch(() => {});
        hitCount(v === 'up' ? kU : kD)
          .then((n) => { if (counts[v] !== null) { counts[v] = Math.max(counts[v], n); render(true); } })
          .catch(() => { /* vote retenu sur l'appareil seulement */ });
      });
    }
  }

  /* ---------- Cartes d'articles (accueil, blog, guides) : lectures et 👍 sur l'image ---------- */
  const queue = [];
  let running = 0;
  const MAX = 4;
  const run = () => {
    while (running < MAX && queue.length) {
      const job = queue.shift();
      running += 1;
      job().catch(() => {}).finally(() => { running -= 1; run(); });
    }
  };
  const enqueue = (job) => { queue.push(job); run(); };
  const fresh = (c) => c && Date.now() - c.t < 10 * 60 * 1000;
  const votesOf = (h) => {
    const c = ss.get('pl-art-ud:' + h);
    if (fresh(c)) return Promise.resolve(c);
    return Promise.all([getCount(key('u', h)), getCount(key('d', h))]).then(([u, d]) => {
      const r = { u, d, t: Date.now() };
      ss.set('pl-art-ud:' + h, r);
      return r;
    });
  };
  const fillViews = (el, n) => {
    if (n < 1) return;
    el.querySelector('[data-n]').textContent = nfCompact.format(n);
    el.setAttribute('title', plural(n, T.view_one, T.view_other));
    el.setAttribute('aria-label', plural(n, T.view_one, T.view_other));
    el.hidden = false;
  };
  const fillProof = (el, r) => {
    const total = r.u + r.d;
    if (total < 1 || r.u < 1) return;
    const pct = Math.round((r.u * 100) / total);
    const label = String(T.useful_short || '').replace('__P__', pct) + ' · ' + plural(total, T.vote_one, T.vote_other);
    // Pourcentage à partir du minimum de votes, sinon le nombre de 👍 (évite « 100 % » sur un seul vote)
    el.querySelector('[data-n]').textContent = total >= MIN_VOTES ? pctFmt(pct) : nf.format(r.u);
    el.setAttribute('title', label);
    el.setAttribute('aria-label', label);
    el.classList.toggle('is-top', total >= MIN_VOTES && pct >= 90);
    el.hidden = false;
  };
  // v96 : pastille des cartes « 👁 lectures · 👍 · 👎 », en haut à droite de l'image ; pouces affichés même à 0
  const fillCardStats = (el, v, r) => {
    const vEl = el.querySelector('.cas--views');
    if (vEl) {
      if (v > 0) { vEl.querySelector('[data-v]').textContent = nfCompact.format(v); vEl.hidden = false; } else { vEl.hidden = true; }
    }
    el.querySelector('[data-up]').textContent = nf.format(r.u);
    el.querySelector('[data-down]').textContent = nf.format(r.d);
    const total = r.u + r.d;
    const pct = total > 0 ? Math.round((r.u * 100) / total) : 0;
    const parts = [];
    if (v > 0) parts.push(plural(v, T.view_one, T.view_other));
    parts.push(String(T.thumbs_label || '').replace('__U__', nf.format(r.u)).replace('__D__', nf.format(r.d)).split('. ')[0]);
    el.setAttribute('title', parts.join(' · '));
    el.classList.toggle('is-top', total >= MIN_VOTES && pct >= 90);
    el.hidden = false;
  };
  const viewsOf = (h) => {
    const c = ss.get('pl-art-v:' + h);
    if (fresh(c)) return Promise.resolve(c.n);
    return getCount(key('v', h)).then((n) => { ss.set('pl-art-v:' + h, { n, t: Date.now() }); return n; });
  };
  const load = (el) => {
    if (el.hasAttribute('data-art-card-stats')) {
      const h = el.getAttribute('data-art-card-stats');
      enqueue(() => Promise.all([viewsOf(h), votesOf(h)]).then(([v, r]) => fillCardStats(el, v, r)));
    } else if (el.hasAttribute('data-art-views-key')) {
      const h = el.getAttribute('data-art-views-key');
      const c = ss.get('pl-art-v:' + h);
      if (fresh(c)) { fillViews(el, c.n); return; }
      enqueue(() => getCount(key('v', h)).then((n) => { ss.set('pl-art-v:' + h, { n, t: Date.now() }); fillViews(el, n); }));
    } else {
      const h = el.getAttribute('data-art-proof-key');
      enqueue(() => votesOf(h).then((r) => fillProof(el, r)));
    }
  };
  const lazy = document.querySelectorAll('[data-art-card-stats], [data-art-views-key], [data-art-proof-key]');
  if (lazy.length && API) {
    if ('IntersectionObserver' in window) {
      // On observe la carte entière : les pastilles sont masquées (display: none) tant qu'elles sont vides, donc jamais « visibles »
      const owner = new Map();
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          (owner.get(en.target) || []).forEach(load);
        });
      }, { rootMargin: '200px' });
      lazy.forEach((el) => {
        const box = el.closest('article') || el.parentElement;
        if (!owner.has(box)) { owner.set(box, []); io.observe(box); }
        owner.get(box).push(el);
      });
    } else {
      lazy.forEach(load);
    }
  }

  /* ---------- Récapitulatif en haut des pages Blog et Guide Puff Land ---------- */
  document.querySelectorAll('[data-art-proof]').forEach((box) => {
    if (!API) return;
    const kind = box.getAttribute('data-art-proof') === 'news' ? 'news' : 'guide';
    const cacheKey = 'pl-art-proof:' + kind;
    const cached = ss.get(cacheKey);
    const get3 = fresh(cached)
      ? Promise.resolve(cached)
      : Promise.all([getCount(key('u', 'k-' + kind)), getCount(key('d', 'k-' + kind)), getCount(key('v', 'k-' + kind))])
        .then(([u, d, v]) => { const r = { u, d, v, t: Date.now() }; ss.set(cacheKey, r); return r; });
    get3.then((r) => {
      const total = r.u + r.d;
      const pctEl = box.querySelector('[data-proof-pct]');
      const labelEl = box.querySelector('[data-proof-label]');
      const votesEl = box.querySelector('[data-proof-votes]');
      const viewsEl = box.querySelector('[data-proof-views]');
      const sep = box.querySelector('.hub-proof__sep');
      const thumbs = box.querySelector('[data-proof-thumbs]');
      if (thumbs) {
        thumbs.querySelector('[data-up]').textContent = nf.format(r.u);
        thumbs.querySelector('[data-down]').textContent = nf.format(r.d);
        thumbs.setAttribute('aria-label', String(T.thumbs_label || '').replace('__U__', nf.format(r.u)).replace('__D__', nf.format(r.d)));
      }
      if (total >= MIN_VOTES && r.u > 0) {
        const pct = Math.round((r.u * 100) / total);
        box.classList.remove('hub-proof--reads');
        animateNumber(pctEl, pct, (x) => pctFmt(x));
        labelEl.textContent = kind === 'news' ? T.proof_news : T.proof_guide;
        votesEl.textContent = plural(total, T.proof_votes_one, T.proof_votes_other);
        if (thumbs) thumbs.hidden = true;
        if (r.v > 0) { viewsEl.textContent = plural(r.v, T.view_one, T.view_other); viewsEl.hidden = false; sep.hidden = false; } else { viewsEl.hidden = true; sep.hidden = true; }
        box.hidden = false;
      } else if (r.v > 0) {
        // Pas encore assez de votes : on met en avant les lectures
        box.classList.add('hub-proof--reads');
        animateNumber(pctEl, r.v, (x) => nfCompact.format(x));
        labelEl.textContent = kind === 'news' ? T.proof_reads_news : T.proof_reads_guide;
        votesEl.textContent = '';
        // Pas encore 3 votes : les 👍 / 👎 s'affichent quand même sous les lectures
        if (thumbs) thumbs.hidden = false;
        viewsEl.hidden = true;
        sep.hidden = true;
        box.hidden = false;
      }
    }).catch(() => { /* service indisponible : rien n'est affiché */ });
  });
})();
